import { $config } from "@/tenant/config"

const routes = [
    {
        name: "support",
        path: "/support",
        beforeEnter: (to) => {
            window.location.href = $config.getExternalUrl(to.path)
        },
    },
    {
        name: "stem",
        path: "/stem",
        alias: "/VUE_APP_DOT_STEM_APP",
        meta: { auth: false },
        beforeEnter: () =>   location.href = process.env["VUE_APP_DOT_STEM_APP"],
    },
    {
        name: "explore",
        path: "/explore",
        alias: "/VUE_APP_DOT_EXPLORE_APP",
        meta: { auth: false },
        beforeEnter: () => location.href = process.env["VUE_APP_DOT_EXPLORE_APP"],
    },
]

const externalUrls = {
    local: {
        "/support": "support.google.apps-dotincorp.com",
        "/account": "account.google.apps-dotincorp.com",
        "/stem": "stem.apps-dotincorp.com",
        "/explore": "cane.google.apps-dotincorp.com",
    },
    dev: {
        "/support": "support.google.apps-dotincorp.com",
        "/account": "account.google.apps-dotincorp.com",
        "/stem": "stem.apps-dotincorp.com",
        "/explore": "cane.google.apps-dotincorp.com",
    },
    real: {
        "/support": "support.google.apps-dotincorp.com",
        "/account": "account.google.apps-dotincorp.com",
        "/stem": "stem.apps-dotincorp.com",
        "/explore": "cane.google.apps-dotincorp.com",
    },
}

export { routes as default, externalUrls }
